import { useTranslation } from 'react-i18next';

export const useUserType = (user?: any): string => {
  const { t } = useTranslation('common');
  let userType = '';
  if (user) {
    if (user.userCategoryInternals?.length) {
      userType = t('about.typeInternal');
    } else if (user.userCategoryTransportationProviders?.length) {
      userType = t('about.typeProvider');
    } else if (user.userCategoryServiceAccounts.length) {
      userType = t('about.typeService');
    }
  }
  return userType;
};
